"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCalcFieldJoin = void 0;
const core_shared_1 = require("@ikegps/core-shared");
class IkeCalcFieldJoin {
    constructor(field) {
        this.field = field;
        this.wire = field.parent;
        const form = this.wire.schema.getForm();
        const parentSubFormInstance = this.wire.parent.parent;
        if (form.metadata.import.version >= core_shared_1.IkeCalcVersion.V0_3_0) {
            this.circuit = this.wire;
            this.span = parentSubFormInstance;
        }
        else {
            // IkeCalc V0.2.x
            this.circuit = parentSubFormInstance;
            this.span = this.circuit.parent.parent;
        }
        this.subformInstanceID = this.wire.instanceId;
    }
    getTitle() {
        return `${this.span.title} (${this.span.formTitle})`;
    }
    getFieldValue(subform, fieldId) {
        if (subform == null || !subform.hasField(fieldId)) {
            return null;
        }
        const field = subform.getField(fieldId);
        if (!field.hasValue()) {
            return null;
        }
        return field.displayValue;
    }
    fieldsEqual(subformA, subformB, fieldID) {
        const fieldAValue = this.getFieldValue(subformA, fieldID);
        const fieldBValue = this.getFieldValue(subformB, fieldID);
        return fieldAValue != null && fieldBValue != null && fieldAValue === fieldBValue;
    }
    spansOpposing(spanA, spanB) {
        if (spanA.instanceId === spanB.instanceId) {
            return false;
        }
        if (!spanA.hasField('spanType') || !spanB.hasField('spanType')) {
            return false;
        }
        const spanAType = spanA.getField('spanType').value;
        const spanBType = spanB.getField('spanType').value;
        if (spanAType == null || spanBType == null) {
            return false;
        }
        if (spanAType === 'NEXT_POLE') {
            return spanBType === 'PREVIOUS_POLE';
        }
        if (spanAType === 'PREVIOUS_POLE') {
            return spanBType === 'NEXT_POLE';
        }
        return spanAType === spanBType;
    }
    isDeadend(value) {
        return value != null && value.match(/dead[-_ ]*end/i) != null;
    }
}
exports.IkeCalcFieldJoin = IkeCalcFieldJoin;
//# sourceMappingURL=field.join.ikecalc.js.map